import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "49.798",
  viewBox: "0 0 49.798 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M26.562 35.13V6.654l11.04 10.988 2.468-2.47L24.9 0 9.727 15.17l2.52 2.52L23.034 6.856V35.13"
  }), /*#__PURE__*/_jsx("path", {
    d: "M3.528 27.167H0V50h49.798V27.167H46.27v19.305H3.528"
  })]
});